export default {
  /**
   * @param state
   * @returns {function(string): boolean}
   */
  getListingIsInWishlist: state => listingId => {
    return state.wishlist.findIndex(wishlistItem => wishlistItem.id === listingId) !== -1
  },
}
